import RouteUtils from '~/core/utils/RouteUtils';
import {accountPaths} from '~/paths';
import {OKTA_ROLE} from '~/config';

const routes = [
	{
		title: 'Account details',
		path: accountPaths.detailsPage,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/AccountDetailsPage'); // eslint-disable-line
		}),
	},
	{
		title: 'Manage users',
		path: accountPaths.manageUsersPage,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ManageUsersPage'); // eslint-disable-line
		}),
	},
	{
		title: 'Add user',
		path: accountPaths.addUser,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/UserDetailsPage'); // eslint-disable-line
		}),
	},
	{
		title: 'Edit user',
		path: accountPaths.editUserPattern,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/UserDetailsPage'); // eslint-disable-line
		}),
	},
	{
		title: 'Manage Brokerages',
		path: accountPaths.manageBrokerage,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ManageBrokerage'); // eslint-disable-line
		}),
	},
	{
		title: 'Manage Broker Users',
		path: accountPaths.manageBrokerUsersPattern,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ManageBrokerageUsersPage'); // eslint-disable-line
		}),
	},
	{
		title: 'Add Brokerage User Details Page',
		path: accountPaths.addBrokerageUserDetailsPagePattern,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/BrokerUserDetailsPage'); // eslint-disable-line
		}),
	},
	{
		title: 'Edit Brokerage User Details Page',
		path: accountPaths.editBrokerageUserDetailsPagePattern,
		isDynamicRouteRequired: false,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/BrokerUserDetailsPage'); // eslint-disable-line
		}),
	},
];

export default routes;
